import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import { SupportedCountry } from 'modules/payroll_employees/lib/enums'

export interface IdentifierAttributes {
  id: number | null
  employee_id: number
  social_security_number?: string | null
  tax_id?: string | null
  country: SupportedCountry
}

class Identifier extends Model<IdentifierAttributes> {
  static urlRoot() {
    return '/payroll_employees/identifiers'
  }

  constructor(attr: IdentifierAttributes) {
    super(attr)
    makeObservable(this, {
      id: computed,
      employeeId: computed,
      socialSecurityNumber: computed,
      taxId: computed,
      country: computed,
    })
  }

  get employeeId() {
    return this.attributes.employee_id
  }

  get socialSecurityNumber() {
    return this.attributes.social_security_number
  }

  get taxId() {
    return this.attributes.tax_id
  }

  get country() {
    return this.attributes.country
  }
}

export default Identifier
